'use client';

import { DrawerHeader, DrawerTitle, Skeleton } from '@skin-seoul/design-system';
import { useRegionCurrency } from '@skin-seoul/service';
import CartProductCardSkeleton from './components/CartProductCardSkeleton';
import { CartBenefitsBannerSkeleton } from './components/CartBenefitsBanner.Skeleton';

export const ShoppingBagSkeleton = () => {
  const { currency } = useRegionCurrency();
  return (
    <div
      className="flex h-full min-h-0 w-full flex-col"
      role="status"
      aria-label="Loading shopping bag"
      aria-busy="true"
      data-testid="cart-loading-skeleton"
    >
      <DrawerHeader className="flex h-12 w-full shrink-0 items-center justify-center bg-generic-0 p-3">
        <DrawerTitle className="w-full text-center text-label-large font-medium">My Bag</DrawerTitle>
      </DrawerHeader>
      <div aria-hidden="true" className="min-h-0 w-full flex-1 overflow-hidden px-4 pt-2">
        <CartBenefitsBannerSkeleton currency={currency} />
        <div className="-mx-4 mt-5 h-2 bg-neutral-50" />
        {[0, 1, 2].map((index) => (
          <CartProductCardSkeleton key={index} isFirst={index === 0} showDivider={index < 2} />
        ))}
      </div>
      <div aria-hidden="true" className="w-full shrink-0 bg-generic-0 px-4 pb-4 pt-3">
        <div className="mb-3 flex h-6 items-center justify-between">
          <span className="text-label-medium font-medium">Order total</span>
          <Skeleton className="h-5 w-20 motion-reduce:animate-none" />
        </div>
        <Skeleton className="h-12 w-full rounded-lg motion-reduce:animate-none" />
      </div>
    </div>
  );
};
export default ShoppingBagSkeleton;
